// extracted by mini-css-extract-plugin
module.exports = {"root":"ImageGradientOverlay_root__dRvm9","top":"ImageGradientOverlay_top__VCJX6","bottom":"ImageGradientOverlay_bottom__8rXGh"};